export const getSelectButtonStyle = (
  hasSearchInputInDropdown: boolean,
  isOpen: boolean
) => {
  if (hasSearchInputInDropdown) {
    return undefined;
  }

  return {
    // Hide trigger content while dropdown is open to prevent overlap with
    // the backdrop-layered search input.
    // Search is positioned exactly over the trigger; keyboard focus is
    // trapped within the backdrop scope.
    // Uses visibility: hidden (instead of just opacity: 0) to ensure hidden
    // elements are correctly removed from the accessibility tree.
    opacity: isOpen ? 0 : 1,
    visibility: isOpen ? 'hidden' : 'visible',
  } as const;
};
